// extracted by mini-css-extract-plugin
export default {"grid-alike-section":"BoxSection_grid-alike-section__17emn","grid-header-right":"BoxSection_grid-header-right__0Pagh"};